import { keepPreviousData, useQuery } from "@tanstack/react-query";
import uniqWith from "lodash/uniqWith";
import isEqual from "lodash/isEqual";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { onError } from "util/conditional/onError";
export const definitionsUrl = (definitionId) => qualifyUrl(`/events/definitions/${definitionId}`);
const transformExpressionsToArray = ({ series, conditions }) => {
  const res = [];
  const rec = (expression) => {
    if (!expression) {
      return "No condition configured";
    }
    switch (expression.expr) {
      case "number":
        return { value: expression.value };
      case "number-ref":
        const numberRefSeries = series.find((s) => s.id === expression.ref);
        return (numberRefSeries == null ? void 0 : numberRefSeries.type) ? { field: `${numberRefSeries.type}(${numberRefSeries.field || ""})` } : null;
      case "&&":
      case "||":
        return [rec(expression.left), rec(expression.right)];
      case "group":
        return [rec(expression.child)];
      case "<":
      case "<=":
      case ">":
      case ">=":
      case "==":
        const { ref } = expression.left;
        const selectedSeries = series.find((s) => s.id === ref);
        const fnSeries = (selectedSeries == null ? void 0 : selectedSeries.type) ? `${selectedSeries.type}(${selectedSeries.field || ""})` : void 0;
        res.push({
          expr: expression.expr,
          value: expression.right.value,
          function: selectedSeries == null ? void 0 : selectedSeries.type,
          fnSeries,
          field: selectedSeries == null ? void 0 : selectedSeries.field
        });
        return [rec(expression.left), rec(expression.right)];
      default:
        return null;
    }
  };
  rec(conditions.expression);
  return res;
};
const eventDefinitionDataMapper = (data) => {
  var _a, _b;
  return {
    eventDefinition: data,
    aggregations: ((_a = data == null ? void 0 : data.config) == null ? void 0 : _a.series) && ((_b = data == null ? void 0 : data.config) == null ? void 0 : _b.conditions) ? uniqWith(
      transformExpressionsToArray({ series: data.config.series, conditions: data.config.conditions }),
      isEqual
    ) : []
  };
};
const fetchDefinition = (definitionId) => fetch("GET", definitionsUrl(definitionId)).then(eventDefinitionDataMapper);
const useEventDefinition = (definitionId, { onErrorHandler } = {}) => {
  const { data, refetch, isLoading, isFetched } = useQuery({
    queryKey: ["event-definition-by-id", definitionId],
    queryFn: () => onError(fetchDefinition(definitionId), (errorThrown) => {
      if (onErrorHandler) onErrorHandler(errorThrown);
      UserNotification.error(
        `Loading event definition failed with status: ${errorThrown}`,
        "Could not load event definition"
      );
    }),
    placeholderData: keepPreviousData,
    enabled: !!definitionId,
    initialData: {
      eventDefinition: null,
      aggregations: []
    }
  });
  return {
    data,
    refetch,
    isLoading,
    isFetched
  };
};
export default useEventDefinition;
